import { NavLink } from "react-router-dom";
import { Home, GraduationCap, CalendarCheck2, Library } from "lucide-react";
import { useT } from "@/hooks/useT";

export default function BottomNav() {
  const { t } = useT();
  const tabs = [
    { to: "/", label: t("nav_home"), Icon: Home, end: true },
    { to: "/academy", label: t("nav_academy"), Icon: GraduationCap },
    { to: "/planner", label: t("nav_planner"), Icon: CalendarCheck2 },
    { to: "/library", label: t("nav_library"), Icon: Library },
  ];
  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0B0E14]/90 backdrop-blur-2xl border-t border-white/10"
      style={{
        // Honour iPhone home-indicator inset. `max(env(...), 0px)` is the
        // safe form — older iOS Safari returns NaN for unset envs which
        // breaks `paddingBottom`. The 0px floor keeps non-iOS phones unaffected.
        paddingBottom: "max(env(safe-area-inset-bottom), 0px)",
        paddingLeft: "max(env(safe-area-inset-left), 0px)",
        paddingRight: "max(env(safe-area-inset-right), 0px)",
      }}
      data-testid="bottom-nav"
    >
      <ul className="flex items-stretch justify-between px-1 py-1.5 max-w-screen-sm mx-auto w-full">
        {tabs.map(({ to, label, Icon, end }) => (
          <li key={to} className="flex-1 min-w-0">
            <NavLink
              to={to}
              end={end}
              data-testid={`bnav-${to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 rounded-lg py-2 px-1 text-[10px] font-display tracking-wide transition w-full ${
                  isActive ? "text-white" : "text-white/40 hover:text-white/80"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={20} className={isActive ? "text-[#00FF9D] drop-shadow-[0_0_10px_rgba(0,255,157,0.6)]" : ""} />
                  <span className="truncate max-w-full">{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
